// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

.share-list {
  margin-top: 24px;
}
.share-list .share-list-title {
  display: flex;
  align-content: flex-end;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 0.75rem;
}
.share-list .share-list-title h5 {
  color: #0A4064;
  margin-bottom: 0px;
}
.share-list .existing-share-section {
  margin-top: 32px;
}
.share-list .existing-share-section .group-share-block {
  margin-top: 16px;
}
.share-list .existing-share-section .group-title {
  font-size: 16px;
  margin-left: 4px;
}
.share-list .share-save-btn {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  margin-right: -10px;
}
.share-list .create-new-form {
  display: flex;
}
.share-list .create-new-form h5 {
  color: #0A4064;
  margin-bottom: 0.75rem;
}

.group-share-wrapper {
  padding: 2rem;
  background-color: #EDf0F1;
  font-family: inherit;
  width: 100%;
}

.group-share-header {
  margin-bottom: 2rem;
}
.group-share-header h2 {
  color: #0A4064;
  font-size: 1.75rem;
  margin-bottom: 0.25rem;
}
.group-share-header p {
  color: #444343;
  font-size: 1rem;
}

.shares-helper-text {
  margin-bottom: 1rem;
}

.epr-selector {
  display: flex;
  align-items: center;
  margin-bottom: 2rem;
}
.epr-selector h5 {
  color: #0A4064;
  margin-bottom: 0px;
}
.epr-selector .epr-select-dropdown {
  margin-left: 1rem;
  padding: 0.5rem 0.75rem;
  font-size: 1.25rem;
  font-weight: 600;
  border: 2px solid #0A4064;
  border-radius: 8px;
  background-color: white;
  color: #0A4064;
  cursor: pointer;
}
.epr-selector .epr-select-dropdown:hover {
  background-color: #EDf0F1;
}
.epr-selector .epr-options {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
}
.epr-selector .button-outline {
  background-color: white;
  color: #0A4064;
  border: 2px solid #0A4064;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: center;
}
.epr-selector .button-outline.active {
  background-color: #0A4064;
  color: white;
}
.epr-selector .button-outline:hover {
  background-color: #0A4064;
  color: white;
  opacity: 0.9;
}
.epr-selector .button-outline:disabled {
  background-color: #D1D3D4;
  border-color: #A7A9AC;
  color: #808080;
  cursor: not-allowed;
}

.group-tabs {
  margin-bottom: 2rem;
}
.group-tabs h5 {
  margin-bottom: 0.75rem;
  color: #0A4064;
}
.group-tabs .group-tab-list {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}
.group-tabs .button-outline {
  background-color: white;
  color: #0A4064;
  border: 2px solid #0A4064;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: center;
}
.group-tabs .button-outline.active {
  background-color: #0A4064;
  color: white;
}
.group-tabs .button-outline:hover {
  background-color: #0A4064;
  color: white;
  opacity: 0.9;
}
.group-tabs .button-outline:disabled {
  background-color: #D1D3D4;
  border-color: #A7A9AC;
  color: #808080;
  cursor: not-allowed;
}

.animated-slide {
  animation: fadeInSlideUp 0.7s ease-out;
}

@keyframes fadeInSlideUp {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.share-form-wrapper {
  background-color: white;
  border: 1px solid #A7A9AC;
  border-radius: 5px;
  padding: 2rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.step-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #EDf0F1;
  border: 1px solid #A7A9AC;
  border-radius: 6px;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
}
.step-summary span {
  font-weight: 600;
  color: #0A4064;
}
.step-summary .change-btn {
  background: none;
  border: none;
  color: #0669B3;
  font-size: 0.9rem;
  font-weight: 500;
  cursor: pointer;
  padding: 0.25rem 0.5rem;
  transition: color 0.2s ease;
}
.step-summary .change-btn:hover {
  color: #0A4064;
  text-decoration: underline;
}

.epr-options,
.share-mode-options,
.step-summary {
  transition: all 0.3s ease;
}

.epr-options,
.share-mode-options {
  animation: fadeInSlideDown 0.3s ease;
}

@keyframes fadeInSlideDown {
  0% {
    opacity: 0;
    transform: translateY(-6px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
.group-mode-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.group-mode-wrapper .mode-help-text {
  margin-top: 0.25rem;
  font-size: 0.85rem;
  color: #808080;
  padding-left: 0.5rem;
}

.share-mode {
  margin-bottom: 2rem;
}
.share-mode h5 {
  margin-bottom: 0.75rem;
  color: #0A4064;
}
.share-mode .share-mode-options {
  display: flex;
  gap: 1rem;
}
.share-mode .share-mode-options > * {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}
.share-mode .share-mode-options .button-outline {
  background-color: white;
  color: #0A4064;
  border: 2px solid #0A4064;
  padding: 0.75rem 1.5rem;
  font-weight: 600;
  font-size: 1rem;
  border-radius: 8px;
  transition: all 0.2s ease;
  text-align: center;
}
.share-mode .share-mode-options .button-outline.active {
  background-color: #0A4064;
  color: white;
}
.share-mode .share-mode-options .button-outline:hover {
  background-color: #0A4064;
  color: white;
  opacity: 0.9;
}
.share-mode .share-mode-options .button-outline:disabled {
  background-color: #D1D3D4;
  border-color: #A7A9AC;
  color: #808080;
  cursor: not-allowed;
}
.share-mode .share-mode-options .button-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.3;
}
.share-mode .share-mode-options .button-label {
  font-weight: 600;
  font-size: 1.15rem;
}
.share-mode .share-mode-options .button-helper {
  font-size: 0.8rem;
  font-weight: 500;
}
.share-mode .share-mode-options .mode-help-text {
  font-size: 0.85rem;
  color: #444343;
  margin-top: 0.5rem;
  text-align: center;
}

.modal-open .modal-backdrop {
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 1 !important;
}

@media (max-width: 1403px) {
  .share-mode .share-mode-options .button-outline .button-helper {
    font-size: 0.7rem;
    font-weight: 500;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/GroupShare.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;ADJA;;;EAGI,sBAAA;ACOJ;;AAPA;EACE,gBAAA;AAUF;AARE;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,WAAA;EAEA,sBAAA;AASJ;AAPI;EACE,cDNI;ECOJ,kBAAA;AASN;AALE;EACE,gBAAA;AAOJ;AALI;EACE,gBAAA;AAON;AAJI;EACE,eAAA;EACA,gBAAA;AAMN;AAFE;EACE,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;AAIJ;AADE;EACE,aAAA;AAGJ;AADI;EACE,cDnCI;ECoCJ,sBAAA;AAGN;;AAEA;EACE,aAAA;EACA,yBD3BM;EC4BN,oBAAA;EACA,WAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;EACE,cDpDM;ECqDN,kBAAA;EACA,sBAAA;AACJ;AAEE;EACE,cDpCK;ECqCL,eAAA;AAAJ;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AADF;AAGE;EACE,cDzEM;EC0EN,kBAAA;AADJ;AAIE;EACE,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,cDrFM;ECsFN,eAAA;AAFJ;AAII;EACE,yBDzEE;ACuER;AAME;EACE,aAAA;EACA,eAAA;EACA,SAAA;AAJJ;AAOE;EACE,uBAAA;EACA,cDrGM;ECsGN,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AALJ;AAOI;EACE,yBD/GI;ECgHJ,YAAA;AALN;AAQI;EACE,yBDpHI;ECqHJ,YAAA;EACA,YAAA;AANN;AASI;EACE,yBDzGE;EC0GF,qBDzGE;EC0GF,cDzGE;EC0GF,mBAAA;AAPN;;AAYA;EACE,mBAAA;AATF;AAWE;EACE,sBAAA;EACA,cDvIM;AC8HV;AAYE;EACE,aAAA;EACA,WAAA;EACA,eAAA;AAVJ;AAaE;EACE,uBAAA;EACA,cDlJM;ECmJN,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAXJ;AAaI;EACE,yBD5JI;EC6JJ,YAAA;AAXN;AAcI;EACE,yBDjKI;ECkKJ,YAAA;EACA,YAAA;AAZN;AAeI;EACE,yBDtJE;ECuJF,qBDtJE;ECuJF,cDtJE;ECuJF,mBAAA;AAbN;;AAkBA;EACE,sCAAA;AAfF;;AAkBA;EACE;IACE,UAAA;IACA,2BAAA;EAfF;EAkBA;IACE,UAAA;IACA,wBAAA;EAhBF;AACF;AAmBA;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,yCAAA;AAjBF;;AAoBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,yBD3LM;EC4LN,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,kBAAA;AAjBF;AAmBE;EACE,gBAAA;EACA,cDnNM;ACkMV;AAoBE;EACE,gBAAA;EACA,YAAA;EACA,cDlMS;ECmMT,iBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;EACA,2BAAA;AAlBJ;AAoBI;EACE,cDjOI;ECkOJ,0BAAA;AAlBN;;AAuBA;;;EAGE,yBAAA;AApBF;;AAuBA;;EAEE,oCAAA;AApBF;;AAuBA;EACE;IACE,UAAA;IACA,2BAAA;EApBF;EAuBA;IACE,UAAA;IACA,wBAAA;EArBF;AACF;AAwBA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAtBF;AAwBE;EACE,mBAAA;EACA,kBAAA;EACA,cDnPI;ECoPJ,oBAAA;AAtBJ;;AA0BA;EACE,mBAAA;AAvBF;AAyBE;EACE,sBAAA;EACA,cDhRM;ACyPV;AA0BE;EACE,aAAA;EACA,SAAA;AAxBJ;AA2BI;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,wBAAA;AAzBN;AA4BI;EACE,uBAAA;EACA,cDjSI;ECkSJ,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AA1BN;AA4BM;EACE,yBD3SE;EC4SF,YAAA;AA1BR;AA6BM;EACE,yBDhTE;ECiTF,YAAA;EACA,YAAA;AA3BR;AA8BM;EACE,yBDrSA;ECsSA,qBDrSA;ECsSA,cDrSA;ECsSA,mBAAA;AA5BR;AAgCI;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AA9BN;AAiCI;EACE,gBAAA;EACA,kBAAA;AA/BN;AAkCI;EACE,iBAAA;EACA,gBAAA;AAhCN;AAmCI;EACE,kBAAA;EACA,cD1TG;EC2TH,kBAAA;EACA,kBAAA;AAjCN;;AAsCA;EACE,0BAAA;EACA,oCAAA;EACA,qBAAA;AAnCF;;AAsCA;EAIQ;IACE,iBAAA;IACA,gBAAA;EAtCR;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$grey0: #EDf0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"../styles/global/Colors\";\n@import \"../styles/global/globalMixins\";\n\n.share-list {\n  margin-top: 24px;\n\n  .share-list-title {\n    display: flex;\n    align-content: flex-end;\n    justify-content: space-between;\n    width: 100%;\n\n    margin-bottom: 0.75rem;\n\n    h5 {\n      color: $dk-blue;\n      margin-bottom: 0px;\n    }\n  }\n\n  .existing-share-section {\n    margin-top: 32px;\n\n    .group-share-block {\n      margin-top: 16px;\n    }\n\n    .group-title {\n      font-size: 16px;\n      margin-left: 4px;\n    }\n  }\n\n  .share-save-btn {\n    margin-top: 1rem;\n    display: flex;\n    justify-content: flex-end;\n    margin-right: -10px;\n  }\n\n  .create-new-form {\n    display: flex;\n\n    h5 {\n      color: $dk-blue;\n      margin-bottom: 0.75rem;\n    }\n  }\n}\n\n.group-share-wrapper {\n  padding: 2rem;\n  background-color: $grey0;\n  font-family: inherit;\n  width: 100%;\n}\n\n.group-share-header {\n  margin-bottom: 2rem;\n\n  h2 {\n    color: $dk-blue;\n    font-size: 1.75rem;\n    margin-bottom: 0.25rem;\n  }\n\n  p {\n    color: $grey4a;\n    font-size: 1rem;\n  }\n}\n\n.shares-helper-text {\n  margin-bottom: 1rem;\n}\n\n.epr-selector {\n  display: flex;\n  align-items: center;\n  margin-bottom: 2rem;\n\n  h5 {\n    color: $dk-blue;\n    margin-bottom: 0px;\n  }\n\n  .epr-select-dropdown {\n    margin-left: 1rem;\n    padding: 0.5rem 0.75rem;\n    font-size: 1.25rem;\n    font-weight: 600;\n    border: 2px solid $dk-blue;\n    border-radius: 8px;\n    background-color: white;\n    color: $dk-blue;\n    cursor: pointer;\n\n    &:hover {\n      background-color: $grey0;\n    }\n  }\n\n  .epr-options {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 1rem;\n  }\n\n  .button-outline {\n    background-color: white;\n    color: $dk-blue;\n    border: 2px solid $dk-blue;\n    padding: 0.75rem 1.5rem;\n    font-weight: 600;\n    font-size: 1rem;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    text-align: center;\n\n    &.active {\n      background-color: $dk-blue;\n      color: white;\n    }\n\n    &:hover {\n      background-color: $dk-blue;\n      color: white;\n      opacity: .9;\n    }\n\n    &:disabled {\n      background-color: $grey1;\n      border-color: $grey2;\n      color: $grey3;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.group-tabs {\n  margin-bottom: 2rem;\n\n  h5 {\n    margin-bottom: 0.75rem;\n    color: $dk-blue;\n  }\n\n  .group-tab-list {\n    display: flex;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n  }\n\n  .button-outline {\n    background-color: white;\n    color: $dk-blue;\n    border: 2px solid $dk-blue;\n    padding: 0.75rem 1.5rem;\n    font-weight: 600;\n    font-size: 1rem;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n    text-align: center;\n\n    &.active {\n      background-color: $dk-blue;\n      color: white;\n    }\n\n    &:hover {\n      background-color: $dk-blue;\n      color: white;\n      opacity: .9;\n    }\n\n    &:disabled {\n      background-color: $grey1;\n      border-color: $grey2;\n      color: $grey3;\n      cursor: not-allowed;\n    }\n  }\n}\n\n.animated-slide {\n  animation: fadeInSlideUp 0.7s ease-out;\n}\n\n@keyframes fadeInSlideUp {\n  0% {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.share-form-wrapper {\n  background-color: white;\n  border: 1px solid $grey2;\n  border-radius: 5px;\n  padding: 2rem;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.step-summary {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background-color: $grey0;\n  border: 1px solid $grey2;\n  border-radius: 6px;\n  padding: 0.75rem 1rem;\n  margin-top: 0.5rem;\n\n  span {\n    font-weight: 600;\n    color: $dk-blue;\n  }\n\n  .change-btn {\n    background: none;\n    border: none;\n    color: $pearl-blue;\n    font-size: 0.9rem;\n    font-weight: 500;\n    cursor: pointer;\n    padding: 0.25rem 0.5rem;\n    transition: color 0.2s ease;\n\n    &:hover {\n      color: $dk-blue;\n      text-decoration: underline;\n    }\n  }\n}\n\n.epr-options,\n.share-mode-options,\n.step-summary {\n  transition: all 0.3s ease;\n}\n\n.epr-options,\n.share-mode-options {\n  animation: fadeInSlideDown 0.3s ease;\n}\n\n@keyframes fadeInSlideDown {\n  0% {\n    opacity: 0;\n    transform: translateY(-6px);\n  }\n\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.group-mode-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  .mode-help-text {\n    margin-top: 0.25rem;\n    font-size: 0.85rem;\n    color: $grey3;\n    padding-left: 0.5rem;\n  }\n}\n\n.share-mode {\n  margin-bottom: 2rem;\n\n  h5 {\n    margin-bottom: 0.75rem;\n    color: $dk-blue;\n  }\n\n  .share-mode-options {\n    display: flex;\n    gap: 1rem;\n\n    // Make both button areas the same width & height\n    >* {\n      flex: 1;\n      display: flex;\n      flex-direction: column;\n      justify-content: stretch;\n    }\n\n    .button-outline {\n      background-color: white;\n      color: $dk-blue;\n      border: 2px solid $dk-blue;\n      padding: 0.75rem 1.5rem;\n      font-weight: 600;\n      font-size: 1rem;\n      border-radius: 8px;\n      transition: all 0.2s ease;\n      text-align: center;\n\n      &.active {\n        background-color: $dk-blue;\n        color: white;\n      }\n\n      &:hover {\n        background-color: $dk-blue;\n        color: white;\n        opacity: .9;\n      }\n\n      &:disabled {\n        background-color: $grey1;\n        border-color: $grey2;\n        color: $grey3;\n        cursor: not-allowed;\n      }\n    }\n\n    .button-content {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      line-height: 1.3;\n    }\n\n    .button-label {\n      font-weight: 600;\n      font-size: 1.15rem;\n    }\n\n    .button-helper {\n      font-size: 0.8rem;\n      font-weight: 500;\n    }\n\n    .mode-help-text {\n      font-size: 0.85rem;\n      color: $grey4a;\n      margin-top: 0.5rem;\n      text-align: center;\n    }\n  }\n}\n\n.modal-open .modal-backdrop {\n  backdrop-filter: blur(5px);\n  background-color: rgba(0, 0, 0, 0.6);\n  opacity: 1 !important;\n}\n\n@media (max-width: 1403px) {\n  .share-mode {\n    .share-mode-options {\n      .button-outline {\n        .button-helper {\n          font-size: .70rem;\n          font-weight: 500;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
